module.exports = __webpack_public_path__ + "img/202601_04.aade8646.png";